// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","RatingOverlay":"_1pUcF6","RatingText":"_21f72z","fadeInFrames":"_2Hhimn"};